<template>
  <div
    id="header"
    class="block-header header"
    :class="[device_platform, { header_scrolled: is_scrolled }]"
  >
    <div class="header__container container">
      <img src="../images/logo/logo.svg" alt="Audi" class="header__logo" />
      <div class="space"></div>
      <div class="space"></div>

      <header-nav :is_open="nav_is_open" @close="closeNav"></header-nav>

      <a
        v-if="device_platform !== 'mobile'"
        :href="'tel:+' + CONSTANTS.phone_raw"
        class="header__phone call_phone_1"
      >
        {{ CONSTANTS.phone }}
      </a>

      <button
        v-if="device_platform === 'desktop'"
        class="header__btn button button_theme_secondary"
        @click="
          getCall({ type: 'sale', form: 'header', title: 'Оставить заявку' })
        "
      >
        <span>Оставить заявку</span>
      </button>

      <img
        v-if="device_platform === 'mobile'"
        src="../images/utils/burger.svg"
        alt="Menu"
        class="header__burger"
        @click="openNav"
      />
    </div>
  </div>
</template>

<script>
import HeaderNav from "./nav";

import Mixin from "../common/mixin";
import $ from "jquery";

export default {
  name: "block-header",
  components: { HeaderNav },
  mixins: [Mixin],
  data() {
    return {
      is_scrolled: 0,
      nav_is_open: false,
    };
  },
  mounted() {
    $("html").on("keyup", (event) => {
      if (event.keyCode === 27) {
        this.show.creq = false;
      }
    });
    $(window).on("scroll", () => {
      this.is_scrolled = window.scrollY > 75;
    });
    this.is_scrolled = window.scrollY > 75;
  },
  methods: {
    scrollTo(where) {
      this.$emit("scrollTo", where);
    },
    openNav() {
      this.nav_is_open = true;
      this.blockScroll();
    },
    closeNav() {
      this.nav_is_open = false;
      this.unblockScroll();
    },
  },
};
</script>

<style scoped lang="scss">
@import "../styles/constants.scss";

.header {
  position: fixed;
  z-index: 100;
  left: 0;
  right: 0;
  top: 0;
  background-color: transparent;
  background-color: rgba($color: #000000, $alpha: 0.8);
  color: $white;
  font-size: 18px;
  transition: $transition;

  &.header_scrolled {
    background-color: rgba($color: #000000, $alpha: 0.8);

    .header__container {
      padding-top: 10px;
      padding-bottom: 10px;
    }
  }

  &__container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    //padding-top: 22px;
    //padding-bottom: 22px;
    padding-top: 10px;
    padding-bottom: 10px;
    transition: $transition;
  }

  &__logo {
  }

  &__phone {
    font-size: calcFontSize(14, 18, 800, 1920);
    text-shadow: 1px 1px 2px #000;
    margin-right: 8em;
    @media (max-width: 1200px) {
      margin-right: 0;
      margin-left: 5em;
    }
  }

  &__btn {
  }

  &__burger {
    cursor: pointer;
  }
}

@media (max-width: 640px) {
  .header {
    &__logo {
      max-width: 128px;
    }
  }
}
</style>
